import { Component, Inject, OnInit } from '@angular/core';
import { ComponentDetails } from '../../../../../app/modules/manage-equipment/models/manage-equipment.model';
import { ManageEquipmentService } from '../../../manage-equipment/manage-equipment.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { EqualiserBar } from '../../../../entities/setup/model';

@Component({
  selector: 'app-action-comment',
  templateUrl: './action-comment.component.html',
  styleUrls: ['./action-comment.component.scss']
})
export class ActionCommentComponent implements OnInit {
  comment:string;
  Component?:ComponentDetails;
  equaliserBar?: EqualiserBar;
  eqComment?: string;
  constructor(
    public dialogRef: MatDialogRef<ActionCommentComponent>,
    @Inject(MAT_DIALOG_DATA) private _data: any,
    private _manageEquipmentService: ManageEquipmentService
  ) { }

  ngOnInit(): void {
    this.equaliserBar = this._data.EqualiserBar;
    this.Component = this._data.Component;
    if (this.equaliserBar) {
      this.comment = this.equaliserBar.ActionComment ?? '';
    } else if (this.Component) {
      this.comment = this.Component.ActionComment ?? '';
    }
  }
  onNoClick(): void {
    this.dialogRef.close();
  }
  save(): void {
    if (this.equaliserBar) {
      this.equaliserBar.ActionComment = this.comment;
      this.dialogRef.close(this.equaliserBar);
    } else if (this.Component) {
      this.Component.ActionComment = this.comment;
      this.dialogRef.close(this.Component);
    }
  }
}